<template>
  <div><PageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'production-qualityInspection',
  components: { PageTable },
}
</script>
